<template>
    <!-- display customer account -->
    <div class="container-fluid">
        <div class="row my-3">
            <div class="col-sm-4 col-9">
                <h4>Address</h4>
            </div>
            <div class="col-sm-8 col-3 text-right">
                <router-link :to="{ name: 'customer-account' }" class="btn btn-outline-dark btn-sm">
                    <i class="fas fa-user-circle"></i> 
                    <span class="d-none d-sm-inline"> 
                        <span v-if="user && user.firstName" class="add-ellipsis"> {{user.firstName | capitalize}}!</span> 
                        <span v-else>Account</span>
                    </span>
                </router-link>
            </div>
        </div>

        <!-- display alert message desktop view -->
        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-3 mt-n3 p-1`" role="alert">
            <i class="fas fa-exclamation-circle"></i> {{ msg }}
        </div>

        <div class="row">
            <div class="col-12">
                <p>
                    You can manage your saved addresses below. To add a new address, check the 
                    "Save this address for next time" on the checkout-information page.
                </p>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-3">
                <div class="card">
                    <div class="card-header bg-dark text-white">
                        <h5>Saved Address</h5>
                    </div>
                    <div class="card-body">
                        <div v-if="theAddresses">
                            <div v-for="(address, x) in theAddresses" :key="x" class="mb-5">
                                <p class="font-weight-bold my-0">
                                    {{address.firstName | capitalize}}
                                    {{address.lastName | capitalize}}
                                </p>
                                <p>
                                    {{address.address}},
                                    {{address.address2}} <br>
                                    {{address.city | capitalize}}, <br>
                                    {{address.state | capitalize}}, <br>
                                    {{address.country | capitalize}} {{address.zipCode}} <br>
                                    {{address.phone}} <br>
                                    <button @click.prevent="removeAddressFxn(address._id)" class="btn btn-outline-danger btn-sm">
                                        <i class="fas fa-trash-alt"></i> Remove Address
                                    </button>
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <p>None</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "CustomerAddresses",
    data() {
        return {
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['deleteAddressesAction']),
        removeAddressFxn(theAddressId) {
            let addressObj = {
                userId: this.user._id,
                addressId: theAddressId
            }
            this.deleteAddressesAction(addressObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = 'Unable to fetch addresses at this time! Try again'
            })
        }
    },
    computed: {
        ...mapGetters(['user', 'setAddresses']),
        theAddresses() {
            if(this.setAddresses && this.setAddresses.length) {
                return this.setAddresses
            }
            return false
        },
    },
    created() {
        webpageTitle(`Saved address`)
        this.$emit('update:layout', LayoutGeneral);
    }
}
</script>